/*Sidebar*/
/*eslint-disable */
import i_vias from './../UI/icons/Sidebar/Vias.svg'
import i_vias2 from './../UI/icons/Sidebar/Vias2.svg'
import i_beneficios from './../UI/icons/Sidebar/Beneficios.svg'
import i_beneficios2 from './../UI/icons/Sidebar/Beneficios2.svg'
import i_amenidades from './../UI/icons/Sidebar/Amenidades.svg'
import i_amenidades2 from './../UI/icons/Sidebar/Amenidades2.svg'
import i_etapas from './../UI/icons/Sidebar/Etapas.svg'
import i_etapas2 from './../UI/icons/Sidebar/Etapas2.svg'
import i_vistas from './../UI/icons/Sidebar/Vistas.svg'
import i_vistas2 from './../UI/icons/Sidebar/Vistas2.svg'

import i_renders from './../UI/icons/Galerias/renders.svg'
import i_recor from './../UI/icons/Galerias/360.svg'
import i_back from './../UI/icons/back-btn.svg'

/*Amenities*/

import i_bbq from './../UI/icons/Amenities/BBQ.svg'
import i_cocina_social from './../UI/icons/Amenities/Cocina Social.svg'
import i_coffe_room from './../UI/icons/Amenities/Coffe room.svg'
import i_coworking from './../UI/icons/Amenities/Coworking.svg'
import i_gym from './../UI/icons/Amenities/Gym.svg'
import i_kids_area from './../UI/icons/Amenities/Kids Area.svg'
import i_porteria from './../UI/icons/Amenities/Porteria.svg'
import i_salon_yoga from './../UI/icons/Amenities/SalonYoga.svg'
import i_spa_mascota from './../UI/icons/Amenities/SpaMascotas.svg'
import i_terraza from './../UI/icons/Amenities/Terraza.svg'

import i_bbq2 from './../UI/icons/Amenities/BBQ2.svg'
import i_cocina_social2 from './../UI/icons/Amenities/Cocina Social2.svg'
import i_coffe_room2 from './../UI/icons/Amenities/Coffe room2.svg'
import i_coworking2 from './../UI/icons/Amenities/Coworking2.svg'
import i_gym2 from './../UI/icons/Amenities/Gym2.svg'
import i_kids_area2 from './../UI/icons/Amenities/Kids Area2.svg'
import i_porteria2 from './../UI/icons/Amenities/Porteria2.svg'
import i_salon_yoga2 from './../UI/icons/Amenities/SalonYoga2.svg'
import i_spa_mascota2 from './../UI/icons/Amenities/SpaMascotas2.svg'
import i_terraza2 from './../UI/icons/Amenities/Terraza2.svg'

/*POIS*/
import i_salud from './../UI/icons/POI/Salud.svg'
import i_comercio from './../UI/icons/POI/Comercio.svg'
import i_transporte from './../UI/icons/POI/Transporte.svg'
import i_otros from './../UI/icons/POI/Otros.svg'
import i_colegios from './../UI/icons/POI/Educacion.svg'
import i_parques from './../UI/icons/POI/Parques.svg'
import i_supermercado from './../UI/icons/POI/Supermercados.svg'

import i_salud2 from './../UI/icons/POI/Salud2.svg'
import i_comercio2 from './../UI/icons/POI/Comercio2.svg'
import i_transporte2 from './../UI/icons/POI/Transporte2.svg'
import i_otros2 from './../UI/icons/POI/Otros2.svg'
import i_colegios2 from './../UI/icons/POI/Educacion2.svg'
import i_parques2 from './../UI/icons/POI/Parques2.svg'
import i_supermercado2 from './../UI/icons/POI/Supermercados2.svg'


export default {
    /*Sidebar*/
    'vias': i_vias,
    'vias2': i_vias2,
    'beneficios': i_beneficios,
    'beneficios2': i_beneficios2,
    'amenidades': i_amenidades,
    'amenidades2': i_amenidades2,
    'etapas': i_etapas,
    'etapas2': i_etapas2,
    'vistas': i_vistas,
    'vistas2': i_vistas2,
    'renders': i_renders,
    'recorridos': i_recor,
    'back': i_back,

    /*Amenidades*/
    'Lobby': i_porteria,
    'Lobby2': i_porteria2,
    'Social Kitchen': i_cocina_social,
    'Social Kitchen2': i_cocina_social2,
    'Salón de juegos': i_kids_area,
    'Salón de juegos2': i_kids_area2,
    'Coworking': i_coworking,
    'Coworking2': i_coworking2,
    'Spa de mascotas': i_spa_mascota,
    'Spa de mascotas2': i_spa_mascota2,
    'Terraza': i_terraza,
    'Terraza2': i_terraza2,
    'BBQ': i_bbq,
    'BBQ2': i_bbq2,
    'Zona de café': i_coffe_room,
    'Zona de café2': i_coffe_room2,
    'Gym': i_gym,
    'Gym2': i_gym2,
    'Zona de Yoga': i_salon_yoga,
    'Zona de Yoga2': i_salon_yoga2,

    /**/
    "Salud": i_salud,
    "Salud2": i_salud2,
    "Comercio": i_comercio,
    "Comercio2": i_comercio2,
    "Transporte": i_transporte,
    "Transporte2": i_transporte2,
    "Otros": i_otros,
    "Otros2": i_otros2,
    "Educación": i_colegios,
    "Educación2": i_colegios2,
    "Parques": i_parques,
    "Parques2": i_parques2,
    "Supermercados": i_supermercado,
    "Supermercados2": i_supermercado2,
}